export const GET_NOTIFICATION_LIST = 'GET_NOTIFICATION_LIST';
export const GET_NOTIFICATION_REQUEST_COUNT = 'GET_NOTIFICATION_REQUEST_COUNT';
export const GET_NOTIFICATION_FILTER = 'GET_NOTIFICATION_FILTER';
export const GET_NOTIFICATION_UPDATE_COUNT= 'GET_NOTIFICATION_UPDATE_COUNT';
export const GET_NOTIFICATION_HISTORY_COUNT= 'GET_NOTIFICATION_HISTORY_COUNT';
